export default "__VITE_ASSET___VLqV0e7__"